export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_03.1ec557b5.jpg";